import { extend } from './extend.js';

export enum WorkspaceObjectType {
  Folder = 1,
  ProjectParent = 2,
  File = 3,
  Workspace = 4,
  CallTranscript = 5,
  Brand = 6,
}

export enum WorkspaceObjectRole {
  Collaborator = 1,
  Viewer = 2,
  Owner = 3,
  Attendee = 4,
}

/**
 * What a grant of access to an object can be for, besides a single person: everyone in a scope. The ids are those of
 * `ref.workspace_object_access_scope_types`.
 */
export enum WorkspaceObjectAccessScopeType {
  /** One user, by the user's identifier. */
  User = 1,
  /** The members of a brand of the management app, by the brand's identifier. */
  Team = 2,
}

export enum WorkspaceType {
  /** Legacy: nothing creates or reads these any more, but workspaces made earlier still carry them. */
  Personal = 1,
  /** Legacy, see `Personal`. */
  Group = 2,
  AccountApplication = 3,
}

export const WorkspaceTypeMap = new Map([
  [WorkspaceObjectType.Folder, { name: 'Folder' }],
  [WorkspaceObjectType.ProjectParent, { name: 'Project' }],
  [WorkspaceObjectType.Workspace, { name: 'Workspace' }],
  [WorkspaceObjectType.File, { name: 'File' }],
  [WorkspaceObjectType.CallTranscript, { name: 'Transcript' }],
  [WorkspaceObjectType.Brand, { name: 'Brand' }],
]);

export const WorkspaceRoleMap: Record<WorkspaceObjectRole, string> = {
  [WorkspaceObjectRole.Collaborator]: 'Collaborator',
  [WorkspaceObjectRole.Viewer]: 'Viewer',
  [WorkspaceObjectRole.Owner]: 'Owner',
  [WorkspaceObjectRole.Attendee]: 'Attendee',
};

const roleMap = new Map([
  [WorkspaceObjectRole.Collaborator, { name: 'Collaborator' }],
  [WorkspaceObjectRole.Viewer, { name: 'Viewer' }],
  [WorkspaceObjectRole.Owner, { name: 'Owner' }],
  [WorkspaceObjectRole.Attendee, { name: 'Attendee' }],
]);

export default {
  WorkspaceObjectRole: extend(roleMap),
  WorkspaceObjectType: extend(WorkspaceTypeMap),
};
